import {bool, string} from 'prop-types';
import {propEq, pipe, reject, pluck} from 'ramda';
import {fetchJsonV1} from '@sinclair-digital/v2-content-service/lib/fetch';

export interface PackageType {
    value: string;
    checked: boolean;
    label: string;
}

export const packageTypeShape = {
    value: string,
    label: string,
    checked: bool,
};

export const serializePackageTypes = pipe<PackageType[], PackageType[], string[]>(
    reject<PackageType>(propEq('checked', false)),
    pluck('value'),
);

export const parsePackageTypes = (resp: any) => {
    if (Array.isArray(resp)) {
        return resp.map((value: string) => ({
            value,
            label: value.toLowerCase(),
            checked: true,
        }));
    }
    throw Error('Failed to parse PackageTypes');
};

export const updatePackageTypes = (curPackages: PackageType[]) => (resp: any): PackageType[] => {
    if (Array.isArray(resp)) {
        return resp.map((value: string) => ({
            value,
            label: value.toLowerCase(),
            checked: curPackages.some(propEq('value', value)),
        }));
    }
    throw Error('Failed to parse PackageTypes');
};

export const fetchPackageTypes = () => fetchJsonV1('/platform/property/package-type');
